<template>
    <a class="btn btn-wishlist" :href="urlWishList" rel="nofollow" :aria-label="$translate('Ceres::Template.wishList')">
        <svg class="icon icon-heart" fill="currentColor">
            <use xlink:href="#heart" />
        </svg>
        <span class="badge ml-1 d-sm-inline">{{ wishListCount }}</span>
    </a>
</template>

<script>
export default {
    computed:
    {
        wishListCount()
        {
            return this.$store.getters.wishListCount;
        },

        urlWishList()
        {
            return App.urls.wishList;
        }
    }
}
</script>
